import { AttachmentDto } from "src/app/shared/common/attachment/attachment";
import { PhoneTemplate } from "src/app/shared/models/PhoneTemplate";

export class Company {
  id: string;
  crNumber: string;
  identifier: string;
  companyNameAr: string | null;
  companyNameEn: string | null;
  name: string | null;
  companyName: string | null;
  website: string | null;
  email: string | null;
  phone: string | null;
  companyActivity: string | null;
  address: string;
  ownership: string | null;
  expirationDate: Date | null;
  expirationDate_txt: string | null;
  crCreationDate: string | null;
  lastUpdateInfo: string | null;
  companyOwnerId: string;
  companyStatusReason: string;
  companyRequestContacts: CompanyRequestContactAddDto[];
  companyStructures: CompanyStructuresAddDto[];

  commitmentForm_Attach: AttachmentDto[] | null;
  otherAttachments_Attach: AttachmentDto[] | null;
  cR_Attach: AttachmentDto[] | null;
}

export class AddCompany {
  AddCompany(contact: any) {

  }
  id: string;
  companyNameAr: string | null;
  companyNameEn: string | null;
  ownerName: string | null;
  legalTypeName: string | null;
  IsPartners: boolean;
  crNumber: string;
  license_IssueDate: Date | null;
  license_ExpiryDate: Date | null;
  gdrfA_ExpiryDate: Date | null;
  establishmentCardIssueDate: Date | null;
  establishmentNumber: string;
  identifier: string;
  hasValueAddedTax: boolean;
  valueAddedTax: string | null;

  hasCorporateTax: boolean;
  corporateTax: string | null;
  website: string | null;
  email: string | null;
  phone: string | null;
  companyActivity: string;
  address: string;
  ownership: string | null;
  expirationDate: Date | null;
  crCreationDate: string | null;
  lastUpdateInfo: string | null;

  commitmentForm_Attach: AttachmentDto[] | null;
  otherAttachments_Attach: AttachmentDto[] | null;
  cR_Attach: AttachmentDto[] | null;

  companyOwnerId: string;
  companyRequestContacts: CompanyRequestContactAddDto[];
  companyStructures: CompanyStructuresAddDto[];

  companyEmployees: CompanyEmployeeAddDto[];
  companyInvestors: CompanyEmployeeAddDto[];

}
export class CompanyRequestContactAddDto {
  id: string;
  companyProfileRequestId: string;
  contactName: string;
  iqamaNum: string;
  jobTitle: string;
  department: string;
  email: string;
  phone: string;
}

export class CompanyStructuresAddDto {
  id: string;
  companyExecutiveManagement: string;
  name: string;
  iqamaNum: string;
  administrativePosition: string;
  order: number;
  dateOfBirth: string;
}


export class CompanyProfileRequestAddDto {
  id: string | null;
  companyNameAr: string | null;
  crNumber: string;
  ownerName: string;
  licenseNumber: string | null;
  requestStatusId: number;
  license_ExpiryDate: string | null;
  license_IssueDate: string | null;
  gdrfA_ExpiryDate: string | null;
  legalTypeId: number;
  licenseTypeId: number;
  companyCategoryId: number;
  emirateId:number;
  isPartners: boolean | null;
  isSponsor: boolean | null;
  isEjari: boolean | null;
  identifier: string | null;
  employeesNumber: number;
  companyNameEn: string | null;
  website: string | null;
  email: string | null;
  phone: string | null;
  ownership: string | null;
  address: string | null;
  companyActivity: string | null;
  expirationDate: string | null;
  cRCreationDate: string | null;
  lastUpdateInfo: string | null;

  rentalPrice: number;
  rentalNumber: string | null;
  rentalStartDate: string | null;
  rentalEndDate: string | null;

  establishmentCardIssueDate: string | null;
  establishmentNumber: number;
  hasValueAddedTax: boolean | null;
  valueAddedTax: string | null;
  hasCorporateTax: boolean | null;
  corporateTax: string | null;

  containsDubaiMunicipalityForCompany: boolean | null;
  containsDubaiMunicipalityForCompany_Password: string | null;
  containsDubaiMunicipalityForCompany_UserName: string | null;

  containsDubaiMunicipalityForManager: boolean | null;
  containsDubaiMunicipalityForManager_Password: string | null;
  containsDubaiMunicipalityForManager_UserName: string | null;

  containsCustoms: boolean | null;
  containsCustoms_Password: string | null;
  containsCustoms_UserName: string | null;

  containsDubaiCourts: boolean | null;
  containsDubaiCourts_Password: string | null;
  containsDubaiCourts_UserName: string | null;
  //companyOwnerId: string | null;
  companyEmployees: CompanyEmployeeAddDto[];
  companyInvestors: CompanyEmployeeAddDto[];
}

export class CompanyEmployeeAddDto {
  id: string | null;
  name: string | null;
  nameAr: string | null;
  nameEn: string | null;
  birthDate: string | null;
  genderId: number | null;
  nationality: string | null;
  passportNum: string | null;
  passport_IssueDate: string | null;
  passport_ExpiryDate: string | null;
  emiratesIDNum: string | null;
  emiratesID_ExpiryDate: string | null;
  emiratesID_StartDate: string | null;
  residencyNum: string | null;
  residency_ExpiryDate: string | null;
  residency_StartDate: string | null;
  laborCardNum: string | null;
  laborCard_ExpiryDate: string | null;
  unemploymentInsuranceStartDate: string | null;
  unemploymentInsuranceEndDate: string | null;

isManager:boolean|null;
  residenceTypeId :number | null;
  associationFile_Attach: AttachmentDto[] | null;

  unemploymentStartDate: string | null;
  unemploymentEndDate: string | null;
  email: string | null;
  phone: string | null;
  address: string | null;
  unifiedNum: string;
  personalNum: string;
  eSignatureNum: number;
  basicSalary: number;
  totalSalary: number;
  fines: number;
  investorPercentage:number;
  jobTitle: string | null;
  position: string | null;
  jobStartDate: string | null;
  employeeTypeId: number | null;
  companyProfileId: string | null;
  imgSrc: string | null;

}





